/* Generates a synthetic walking route starting at a given lat/lng.
   Used for the "GPS Simulator" test mode and for demo/sample treks. */

const EARTH_R = 6371000;

/* Move a point by (dNorth, dEast) meters. */
function offsetMeters(pt, dNorth, dEast) {
  const dLat = (dNorth / EARTH_R) * (180 / Math.PI);
  const dLng = (dEast / (EARTH_R * Math.cos((pt.lat * Math.PI) / 180))) * (180 / Math.PI);
  return { lat: pt.lat + dLat, lng: pt.lng + dLng };
}

/* Build a wiggly walking path of `steps` points, each ~stepMeters apart. */
export function buildWalkingRoute(start, { steps = 60, stepMeters = 8, seed = 42 } = {}) {
  const points = [{ ...start, altitude: 300, accuracy: 5, speed: 1.2, heading: 0 }];
  let heading = 45; // NE-ish
  let s = seed;
  const rand = () => {
    s = (s * 9301 + 49297) % 233280;
    return s / 233280;
  };
  let alt = 300;
  for (let i = 1; i < steps; i++) {
    // Slight heading drift
    heading += (rand() - 0.5) * 25;
    const rad = (heading * Math.PI) / 180;
    const dN = Math.cos(rad) * stepMeters;
    const dE = Math.sin(rad) * stepMeters;
    const prev = points[points.length - 1];
    const next = offsetMeters(prev, dN, dE);
    alt += (rand() - 0.4) * 3;
    points.push({
      ...next,
      altitude: Math.round(alt),
      accuracy: 4 + rand() * 4,
      speed: 1 + rand() * 0.8,
      heading,
    });
  }
  return points;
}

/* A ready-made demo trek centred on a fictional mountain trailhead. */
export function buildDemoTrek() {
  const start = { lat: 27.9881, lng: 86.9250 }; // Everest region — fictional walk
  const route = buildWalkingRoute(start, { steps: 80, stepMeters: 10, seed: 7 });
  const startedAt = Date.now() - 45 * 60 * 1000;
  const points = route.map((r, i) => ({
    t: startedAt + i * 3000,
    lat: r.lat,
    lng: r.lng,
    accuracy: r.accuracy,
    altitude: r.altitude,
    speed: r.speed,
    heading: r.heading,
  }));
  return {
    id: 'demo-everest-trailhead',
    name: 'Demo — Everest Trailhead Loop',
    isDemo: true,
    startedAt,
    endedAt: startedAt + points.length * 3000,
    points,
    waypoints: [
      { id: 'wp-demo-1', name: 'Cold spring', category: 'water', lat: points[15].lat, lng: points[15].lng, t: points[15].t },
      { id: 'wp-demo-2', name: 'Trail fork', category: 'fork', lat: points[35].lat, lng: points[35].lng, t: points[35].t },
      { id: 'wp-demo-3', name: 'Ridge viewpoint', category: 'view', lat: points[55].lat, lng: points[55].lng, t: points[55].t },
    ],
    status: 'ended',
  };
}
